import React from 'react'
import './faq.css'
import SectionHead from './SectionHead'
import {faqs} from './data'
import FAQ from './FAQ'
import { FaQuestion } from "react-icons/fa";

const FAQs = () => {
  return (
    <section id="faqs" className="faqs__section">
      {/* Background SVG Art */}
      <svg className="faqs__bg-art" viewBox="0 0 1400 600" preserveAspectRatio="xMidYMid slice">
        {/* Left arc cluster */}
        <path d="M-20 300 A200 200 0 0 1 180 100" fill="none" stroke="rgba(79,41,126,0.04)" strokeWidth="1" strokeDasharray="4 8"/>
        <path d="M-40 320 A240 240 0 0 1 200 80" fill="none" stroke="rgba(79,41,126,0.03)" strokeWidth="0.8" strokeDasharray="3 10"/>
        {/* Right arc cluster */}
        <path d="M1420 250 A220 220 0 0 0 1200 470" fill="none" stroke="rgba(26,138,99,0.04)" strokeWidth="1" strokeDasharray="4 8"/>
        <path d="M1440 230 A260 260 0 0 0 1180 490" fill="none" stroke="rgba(26,138,99,0.03)" strokeWidth="0.8" strokeDasharray="3 10"/>
        {/* Node constellation — left */}
        <g opacity="0.06">
          <circle cx="80" cy="150" r="3" fill="#4f297e"/><circle cx="160" cy="200" r="4" fill="#1A8A63"/><circle cx="120" cy="320" r="3" fill="#4f297e"/>
          <line x1="80" y1="150" x2="160" y2="200" stroke="#4f297e" strokeWidth="0.6"/>
          <line x1="160" y1="200" x2="120" y2="320" stroke="#1A8A63" strokeWidth="0.6"/>
        </g>
        {/* Node constellation — right */}
        <g opacity="0.06">
          <circle cx="1300" cy="180" r="4" fill="#1A8A63"/><circle cx="1250" cy="350" r="3" fill="#4f297e"/><circle cx="1340" cy="420" r="3" fill="#1A8A63"/>
          <line x1="1300" y1="180" x2="1250" y2="350" stroke="#4f297e" strokeWidth="0.6"/>
          <line x1="1250" y1="350" x2="1340" y2="420" stroke="#1A8A63" strokeWidth="0.6"/>
        </g>
        {/* Flowing curve */}
        <path d="M0 500Q350 350 700 420T1400 320" fill="none" stroke="rgba(79,41,126,0.03)" strokeWidth="1.2"/>
        {/* Hexagonal fragments — center-left */}
        <g opacity="0.03" stroke="#4f297e" strokeWidth="0.7" fill="none">
          <polygon points="250,420 270,408 290,420 290,444 270,456 250,444"/>
          <polygon points="290,420 310,408 330,420 330,444 310,456 290,444"/>
        </g>
        {/* Question mark motif — very subtle */}
        <g transform="translate(700,50)" opacity="0.025">
          <text x="0" y="0" fontFamily="'Instrument Serif', Georgia, serif" fontSize="180" fill="#4f297e" textAnchor="middle">?</text>
        </g>
        {/* Floating particles */}
        <circle cx="400" cy="100" r="2" fill="#4f297e" opacity="0.04"><animate attributeName="cy" values="100;80;100" dur="8s" repeatCount="indefinite"/></circle>
        <circle cx="1000" cy="480" r="2" fill="#1A8A63" opacity="0.04"><animate attributeName="cy" values="480;460;480" dur="10s" repeatCount="indefinite"/></circle>
      </svg>

      <div className="container faqs__container">
        <SectionHead icon={<FaQuestion/>} title="Frequently Asked Questions"/>
        <div className="faqs__subtitle">Everything you need to know about building your financial foundation. Can{'\u2019'}t find what you{'\u2019'}re looking for? Reach out to us.</div>
        <div className="faqs__wrapper">
          {
            faqs.map(({id, question, answer}) => {
              return <FAQ key={id} question={question} answer={answer}/>
            })
          }
        </div>
      </div>
    </section>
  )
}

export default FAQs